// extracted by mini-css-extract-plugin
export var backdropBlur = "_di-0";
export var contentCard = "_di-5";
export var frame = "_di-2";
export var image = "_di-4";
export var imagePane = "_di-3";
export var modal = "_di-1";